export const formatEuroValue = (value: number, isLithuanianFormat = false): string => {
    const locale = isLithuanianFormat ? 'lt-LT' : 'en-US';

    return value.toLocaleString(locale, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
